@if (options) {
  <div class="select-dropdown-container">
    <div
      ngbDropdown
      #dropdown="ngbDropdown"
      class="dropdown w-100"
      (openChange)="$event && onDropdownOpened()"
    >
      <div
        #dropdownButton
        class="form-select text-start w-100 dropdown-toggle-override custom-dropdown-button"
        [id]="dropdownId"
        role="button"
        tabindex="0"
        [attr.disabled]="control.disabled"
        (click)="onDropdownToggle($event)"
        (keydown)="onKeyDown($event)"
        aria-haspopup="listbox"
        [attr.aria-expanded]="dropdown.isOpen()"
      >
        <span class="dropdown-text">{{ menuItem || placeholder }}</span>
      </div>
      <div
        ngbDropdownMenu
        [attr.aria-labelledby]="dropdownId"
        class="dropdown-menu-scroll w-100 pt-0"
        (click)="$event.stopPropagation()"
      >
        @if (enableTypeahead) {
          <div class="dropdown-search-container px-3 py-2">
            <input
              #searchInput
              type="text"
              class="form-control form-control-sm"
              placeholder="Type to filter..."
              [(ngModel)]="searchTerm"
              (ngModelChange)="onSearchChange($event)"
              (keydown)="onKeyDown($event)"
              (click)="$event.stopPropagation()"
            />
          </div>
        }
        @if (filteredOptions.length === 0) {
          <div class="dropdown-item text-muted">No results found</div>
        }
        @for (option of filteredOptions; track option; let i = $index) {
          <a
            class="dropdown-item selection-background"
            href="#"
            (click)="onSelect(option, $event)"
            (mousedown)="$event.preventDefault()"
            [class.active]="isSelected(option)"
            [class.focused]="isFocused(i)"
            role="option"
            [attr.aria-selected]="isSelected(option)"
          >
            {{ option.name || option.label || option }}
          </a>
        }
      </div>
    </div>
  </div>
}
